export const EventsListSkeleton = ({
  withTitle = false,
  numberOfLines = 10,
}: {
  withTitle?: boolean;
  numberOfLines?: number;
}) => {
  return (
    <div className="w-full">
      {withTitle && (
        <div className="mb-6 h-8 w-64 rounded-lg bg-gray-200"></div>
      )}
      <div className="w-full rounded-lg border border-gray-200">
        <ul>
          {Array.from(Array(numberOfLines).keys()).map((_, index) => (
            <li
              key={index}
              className="grid h-[88px] w-full grid-cols-8 border-t border-gray-200 md:grid-cols-10"
            >
              <div className="col-span-2 flex flex-col items-center justify-center md:col-span-1">
                <div className="mb-1 h-6 w-16 rounded-lg bg-gray-200"></div>
                <div className="h-4 w-16 rounded-lg bg-gray-200"></div>
              </div>
              <div className="col-span-6 flex flex-col justify-center md:col-span-6">
                <div className="mb-2 h-4 w-3/4 rounded-lg bg-gray-200"></div>
                <div className="h-4 w-1/2 rounded-lg bg-gray-200"></div>
              </div>
              <div className="col-span-6 hidden flex-col justify-center md:col-span-2 md:flex">
                <div className="mb-2 h-4 w-4/5 rounded-lg bg-gray-200"></div>
                <div className="h-4 w-1/2 rounded-lg bg-gray-200"></div>
              </div>
              <div className="col-span-1 hidden flex-col justify-center md:col-span-1 md:flex">
                <div className="mb-2 h-4 w-4/5 rounded-lg bg-gray-200"></div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
